import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import ledTheme from 'config/themes/ledTheme';
import Metadata from 'containers/common/sections/Metadata';
import { Router } from 'next/router';
import React, { FC, ReactNode, useEffect } from 'react';

const LedTheme: FC<ReactNode> = ({ children }) => {
  useEffect(() => {
    Router.events.on('routeChangeComplete', () => {
      window.scrollTo(0, 0);
    });
  }, []);

  return (
    <>
      <Metadata />
      <ThemeProvider theme={ledTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </>
  );
};

export default LedTheme;
